import React from "react";

/**
 * Reusable light hero background matching the homepage hero treatment:
 * a purple glow blob centered at the top, layered over the page's cool grey
 * gradient (set on the MarketingLayout body). Drop inside any hero
 * <section> as the first child with `absolute inset-0` so content sits
 * above it.
 */
export default function HeroBackground() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <div
        className="absolute top-[-120px] left-1/2 -translate-x-1/2 w-[800px] h-[440px]"
        style={{ background: "radial-gradient(ellipse at center, rgba(139,92,246,0.22), transparent 62%)" }}
      />
    </div>
  );
}